(function() {
  "use strict";

  angular.module("sempraWebapp").constant("svTranslations", {
    MESSAGE:"Meddelande ",
    ERROR_TITLE:"Fel",
    ERROR_MESSAGE:"Ett fel uppstod ",
    ERROR_LOGIN:"Ett fel uppstod under inloggning. E-postadressen är inte giltig ",
    OK:"OK",
    CANCEL:"Avbryt",
    YES:"Ja",
    NO:"Nej",
    FROM:"Från",
    TO:"Till",
    DELETE:"Radera",
    SIGN_OUT:"Logga ut",
    NAME:"Namn",
    DATE:"Datum",
    PIECES:"Bitar",
    HOURS:"Timmar",
    DAYS:"dagar",
    MONTH:"månad",
    MONTHS:"månader",
    YEAR:"år",
    BOX:"ruta",
    SEARCH:"sök",
    ALL_USERS:"alla användare ",
    ARE_YOU_SURE:"Är du säker?",
    BACK:"tillbaka",
    AMOUNT:"antal",
    DESCRIPTION:"beskrivning",
    FORGOT_PASSWORD_ERROR_MSG:"Något gick fel. Var vänlig kontrollera din e-postadress och försök igen ",
    REQUIRED_FIELD:"fältet är obligatoriskt ",
    LOGOUT_TITLE:"Är du säker på att du vill logga ut? ",
    LOGOUT_MSG:"All osparad information kommer försvinna ",
    ACTIVATION_ACCOUNT:"Du har aktiverat ditt konto ",
    UNKNOWN_ERRROR_NOTIFICATION:"Okänt fel uppstod ",
    CONTINUE:"fortsätt ",
    DATA_NOT_AVAILABLE:"Informationen är ej tillgänglig ",
    SELECT:"välj",
    UPLOAD:"ladda upp",
    PHONE:"mobil",
    WEBSITE:"webbsida",
    WORKING_HOURS:"arbetstimmar ",
    INSERT:"för in",
    TEXT:"text ",
    CREATED:"skapad",
    VALID_UNTIL:"giltig till",
    SAVE:"spara",
    TOKENS:"pollett",
    DELETE_COMPANY_HISTORY:"ta bort företagets historik? ",
    DELETE_COMPANY_HISTORY_MESSAGE:" WARNING: After pressing this button, all transactions of your car wash will be permanently deleted! This data cannot be restored after deletion.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Are you sure you want to permanently delete all transaction data?",
    HISTORY_SUCCESSFULY_DELETED:"historik har raderats ",
    HELP:"Hjälp",
    VALUE:"Värde ",
    ACTIVATING_ACCOUNT_ERROR:"Ett fel med aktiveringen av ditt R2W-konto uppstod. Försök igen och om problemet kvarstår, kontakta vår support på support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Välkommen till Kärcher Fordonstvätt",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Välkommen till R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Ange ditt nya lösenord och bekräfta det för att aktivera R2W-konto. Du kommer automatiskt att bli inloggad",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Du kan ändra dina användarinställningar senare i appen",
    ENTER_NEW_PASSWORD:"Ange nytt lösenord ",
    REPEAT_NEW_PASSWORD:"Upprepa nya lösenordet ",
    PASSWORD_MIN_LENGTH:"Lösenordet måste vara minst 8 tecken långt ",
    PASSWORD_MAX_LENGHT:"lösenordet måste vara mindre än 32 tecken långt ",
    PASSWORD_PATTERN:"Lösenordet måste innehålla minst en stor bokstav och en liten bokstav",
    PASSWORD_MATCH:"lösenorden är inte lika ",
    ACTIVATE:"aktivera ",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Din begäran har skickats. Kontrollera din e-post för bekräftelse",
    VALIDATION_REQUIRED:"Obligatoriskt fält ",
    VALIDATION_EMAIL:"Ogiltig e-postadress",
    VALIDATION_INTEGER_NUMBER:"Vänligen ange ett heltal ",
    VALIDATION_HOURS_VALUE:"värdet måste vara mellan 0-23",
    VALIDATION_MINUTES_VALUE:"värdet måste vara mellan 0-59",
    VALIDATION_NOT_A_DATE:"Värdet är inte ett datum",
    VALIDATION_FROM:"Från datum större än till",
    VALIDATION_TO:"till datum mindre än från",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Den informationen finns redan i databasen",
    PASSWORD_VALIDATION_PATTERN_NEW:"Det måste finnas minst en siffra, en liten bokstav och en stor bokstav. Mellanslag är inte tillåtna",
    VALIDATION_PERCENT_VALUE:"värdet måste vara mellan 1-999",
    NUMBERS_ONLY_100:"Räknar nummer upp till 100",
    NUMBERS_ONLY_1000:"Räknar nummer upp till 1000",
    POSITIVE_NUMBERS_ONLY:"Endast räknande nummer",
    GRID_PAGER_PAGE:"sida",
    GRID_PAGER_ROWS_PER_PAGE:"Rader per sida",
    GRID_PAGER_PAGE_OF:"av",
    BREAD_CRUMBS_HOME:"hem",
    BREAD_CRUMBS_DASHBOARD_TECH:"Hemsidan teknologi ",
    BREAD_CRUMBS_DETAILS:"Detaljer",
    BREAD_CRUMBS_SETTINGS:"Inställningar ",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Dagsrapport totalsumma",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Rapport per timme intäkter",
    BREAD_CRUMBS_NEW_USER_GROUP:"Skapa användargrupp",
    BREAD_CRUMBS_EDIT_USER_GROUP:"redigera användargrupp",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Skapa kampanjmall",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"redigera kampanjmall ",
    BREAD_CRUMBS_NEW_CAMPAIGN:"skapa kampanj ",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"redigera kampanj ",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Sammanfattning för en period",
    LOGIN:"logga in ",
    EMAIL:"e-post",
    PASSWORD:"lösenord ",
    LANGUAGE:"språk",
    FORGOT_PASSWORD:"glömt lösenord? ",
    SUBMIT:"skicka in ",
    HEADER_NUMBER_OF_PENDING_ALARMS:"antal väntande larm:",
    HEADER_VIEW_ALL_ALARMS:"visa alla larm ",
    HEADER_MY_ACCOUNT:"Mitt konto ",
    HEADER_ACCOUNT_MANAGEMENT:"Hantering konto",
    ACCOUNT_ALREADY_EXIST:"E-postadressen används redan",
    NEWSLETTER_CONFIRMATION:"Skicka e-postmeddelande för status larm",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Översikt över dagliga finanser",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Hemsidans teknologi",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Hemsida",
    ASIDE_MENU_ALARMS:"meddelanden ",
    ASIDE_MENU_FACILITIES:"anläggning ",
    ASIDE_MENU_REPORTS:"rapporter ",
    ASIDE_MENU_LOYALTY:"lojalitet ",
    ASIDE_MENU_USER_GROUPS:"användargrupper ",
    ASIDE_MENU_PERIODIC_SUMMARY:"periodisk sammanfattning ",
    ASIDE_MENU_NEWS:"nyheter ",
    DAILY_FINANCES_TOTAL_MONEY:"pengar totalt ",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"pengar totalt för alla anläggningar ",
    DAILY_FINANCES_TOTAL_COINS:"Totalt använda metallpolletter",
    DAILY_FINANCES_DOWNLOAD_CSV:"ladda ned CSV",
    DAILY_FINANCES_ONLINE:"R2W (online) ",
    DAILY_FINANCES_OFFLINE:"Kontanter",
    DAILY_FINANCES_CHANGER:"Kontanter i växlare",
    DAILY_FINANCES_COINS:"polletter/Eurokey",
    REPORTS_FILTER:"filter ",
    REPORTS_TYPE_OF_REPORT:"typ av rapport ",
    REPORTS_CHOOSE_FACILITY:"välj anläggning ",
    REPORTS_PERIOD_1:"period 1-",
    REPORTS_PERIOD_2:"period 2-",
    MONEY_BY_DATE_REPORT:"total inkomst per datum",
    R2W_BY_DATE_REPORT:"Total inkomst från R2W-polletter per datum",
    COINS_BY_DATE_REPORT:"totalt använda polletter per datum",
    AVG_MONEY_BY_HOUR_REPORT:"genomsnittlig inkomst per timme ",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"genomsnittlig inkomst per dag i veckan",
    AVG_MONEY_BY_BOX_REPORT:"utgifterna vid viken ",
    COMPARE_PERIODS_REPORT:"Rapport jämförbara anläggningar",
    TOTAL_USERS_BY_GROUP:"totala R2W-appbesök per dag ",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"användare ",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"besök",
    VISITS_COUNT_REPORT:"Antal R2W-appanvändare per besökantal",
    LOYALTY_PER_DAY_REPORT:"Antal Lokala polletter spenderade per dag ",
    LOYALTY_PER_PAYMENT_METHOD:"Polletter per betalningsmetod",
    VISITS:"besök",
    VISIT:"besök ",
    TOTAL_SPENT_MONEY:"total inkomst ",
    MONEY:"pengar ",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"total inkomst pengar för period ",
    DOWNLOAD_CSV:"ladda ned CVS",
    TOTAL_SPENT_COINS:"totala antal spenderade polletter ",
    TOTAL_USERS:"totala antal användare ",
    TOTAL_CREDIT_GIVEN:"Totala lokala virtuella polletter spenderade ",
    EUROKEY_BY_DATE_REPORT:"totala Eurokey betalningar per datum ",
    TOTAL_SPENT_EUROKEY:"totala köp",
    SELECT_TYPE_OF_REPORT:"Du måste välja rapporttyp :)",
    NUMBER_OF_VISITS_TITLE:"antal besök ",
    NUMBER_OF_USERS_TITLE:"antal användare ",
    PIECES_TITLE:"delar",
    TOTAL_VISITS:"totala besök ",
    TOKENS_TITLE:"polletter ",
    SEARCH_USERS_NO_RESULTS:"Inga användare hittades för det givna sökordet",
    SEARCH_USERS:"sök användare",
    SEARCH_TELEPHONES:"sök användare med mobilnummer ",
    ADD_USER_TO_GROUP:"lägg till användare till grupp",
    REMOVE_USER_FROM_GROUP:"ta bort användare från grupp ",
    USER_GROUP_NAME_REQUIRED:"gruppnamn krävs ",
    USER_GROUP_NAME:"gruppnamn",
    USER_GROUPS_OVERVIEW:"gruppöversikt ",
    USER_COUNT:"användarantal ",
    NEW_USER_GROUP:"skapa ny användargrupp ",
    DELETE_USER_GROUP:"radera användargrupp ",
    UPDATE_USER_GROUP:"redigera användargrupp ",
    DELETE_USER_GROUP_ERROR:"Det gick inte att ta bort vald användargrupp. Försök igen eller kontakta supporten...",
    CONFIRM_DELETE_USER_GROUP:"är du säker på att du vill radera vald användargrupp? ",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Lojalitetsåtgärder som den borttagna gruppen har tilldelats kommer inte längre att vara tillgängliga",
    GROUP_NAME_MAX_LENGTH:"gruppnamnet måste vara mindre än 255 tecken lång ",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"användaren är redan med i gruppen ",
    MISSING_USER:"användare saknas ",
    USER_NOT_ON_LIST:"Användaren finns inte i den aktiva användarlistan. Kontrollera om e-postadressen är giltig och försök igen.",
    UPLOAD_USER_GROUP:"Ladda upp användargruppslistan från * .csv-filen",
    UKNOWN_USERS:"lista på okända användare ",
    CAMPAIGN_TEMPLATE_RULE:"mallregel",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Det har uppstått ett fel vid försök att ta bort kampanjmallen. Vänligen försök igen eller kontakta support ...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"är du säker på att du vill radera vald kampanjmall",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"är du säker på att du vill radera vald kampanjmall",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Översikt över kampanjmallar",
    DELETE_CAMPAIGN_TEMPLATE:"radera kampanjmall ",
    UPDATE_CAMPAIGN_TEMPLATE:"redigera kampanjmall ",
    CREATE_CAMPAIGN_TEMPLATE:"skapa ny kampanjmall ",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"namn på kampanjmallen krävs ",
    CAMPAIGN_TEMPLATE_NAME:"kampanjmall namn ",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"obligatoriskt fält ",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"ge %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"extratid ",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Välj typ först. Tvättbås eller små maskiner",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Radera mallregel",
    CAMPAIGN_TEMPLATE_RULE_FROM:"från ",
    CAMPAIGN_TEMPLATE_RULE_TO:"till",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"timmar ",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuter ",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Ny regel efter antal besök",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"ny regel efter antal spenderade polletter ",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"ny regel efter dagar i veckan ",
    CAMPAIGN_TEMPLATE_ADD_RULE:"lägg till ny mallregel ",
    CAMPAIGN_TEMPLATE_RULE_1:"varje ",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"varje ",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"polletter använda på mindre än",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"besök på mindre än ",
    CAMPAIGN_TEMPLATE_RULE_3:"dagar ",
    CAMPAIGN_TEMPLATE_RULE_4:"polletter ",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"regellista är tom",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"datumet kan inte ha passerats",
    DELETE_CAMPAIGN_ERROR:"Det har uppstått ett fel vid försök att ta bort kampanjen. Vänligen försök igen eller kontakta support ...",
    CONFIRM_DELETE_CAMPAIGN:"är du säker på att du vill radera vald kampanj?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W ansvarar inte för användarupplevelsen som orsakas av denna åtgärd.",
    CAMPAIGNS_OVERVIEW:"översikt över kampanjer ",
    DELETE_CAMPAIGN:"radera kampanj ",
    UPDATE_CAMPAIGN:"redigera kampanj ",
    CREATE_CAMPAIGN:"skapa ny kampanj ",
    CAMPAIGN_ACTIVE:"aktiv ",
    CAMPAIGN_TEMPLATE:"mall",
    CAMPAIGN_GROUPS:"grupp",
    CAMPAIGN_ALL_USERS:"alla användare ",
    CAMPAIGN_NAME:"kampanjnamn ",
    CAMPAIGN_NAME_REQUIRED:"obligatoriskt ",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Antal användare nära max per dag",
    MESSAGE_TO_USERS:"Meddelande till filtrerade användare",
    SEND_MESSAGE:"skicka meddelande ",
    THRESHOLD:"nära max",
    TYPE:"typ",
    TOTAL_MONEY_SPENT:"total summa pengar använda på kampanj ",
    NUMBER_OF_VISITS:"antal besök på kampanj ",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"meddelandet måste vara minst 10 tecken långt ",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"meddelandet måste vara mindre än 350 tecken långt ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"text är obligatoriskt ",
    TECHNOLOGY:"teknologi ",
    TAP_WATER:"Färskvatten ",
    REVERSE_OSMOSIS:"omvänd osmos ",
    SOFTENED_WATER:"Färskvatten ",
    DOSER:"doserare ",
    STATUS:"status",
    LAST_SYNCHRONIZATION:"Sista synkroniseringen",
    NO_OF_CURRENT_ALARMS:"antal aktuella larm ",
    NO_OF_CURRENT_WARNINGS:"antal aktuella varningar ",
    WEATHER:"väder ",
    BOXES_WORK_HOURS_COUNTERS:"Tvättbåsens arbetstid",
    BOX_TOTAL_HOURS:"total arbetstid ",
    BOX_SERVICE_HOURS:"total arbetstid (service) ",
    BOX_COUNTER_HOURS:"timmar",
    ALARMS_AND_WARNINGS:"larm & varningar",
    FILTER_AND_BOILER:"filter & varmvattenberedare",
    FILTER_TOTAL_DAYS:"filter arbetsdagar ",
    BOILER_TOTAL_DAYS:"Varmvattenberedare arbetsdagar ",
    DAYS_UNIT:"dagar ",
    SOFTENER:"mjukmedel ",
    MANUAL_COLD_DRAIN:"instruktion dränering kallvatten",
    EL_COLD:"El. kall",
    DRAIN:"avlopp",
    TAP:"kran",
    WASTE:"Spill",
    OSMOSIS:"osmos ",
    DEMI_WATER:"Demi vatten ",
    EL_RINSE:"El. m. rensa",
    BOILER:"Varmvattenberedare",
    EL_WAX:"El. m. vax ",
    FLOOR_HEATING:"golvvärme ",
    DOSER_TANK:"doseringstank ",
    EL_WASH:"El. m. tvätt",
    DETERGENT:"tvättmedel ",
    VIBRATOR:"vibrator ",
    UPDATE_FACILITY_SETTINGS:"uppdatera inställningar ",
    GENERAL_SETTINGS:"allmänna inställningar ",
    LIGHTS:"lampor ",
    GROUPS:"grupper ",
    ANTI_FREEZE:"frostskydd",
    AUTO:"auto",
    MANUAL:"manuell ",
    ON:"på",
    OFF:"av",
    TEMPERATURE:"temperatur ",
    UPDATE_DEVICE:"uppdatera anläggningsinställningar ",
    BOX_CLEAN_HOURS:"Tvättbås räknare (timmar)",
    GROUP_COUNTERS:"gruppräknare",
    RESET:"återställ",
    CASH_COUNT:"mynt räknas ",
    COINS_COUNT:"polletter räknas ",
    EUROKEY_COUNT:"eurokey räknas ",
    DOSER_WORK:"Doserare arbetstimmar (sek)",
    DOSER_PAUSE:"Doserare pausad tid (sek)",
    DELAY_BFV:"BFV fördröjning (ms)",
    DELAY_6M1:"6M1 fördröjning (ms)",
    DELAY_LPS:"LPS fördröjning (ms)",
    RESET_CASH_COUNT_ALL:"Återställ alla mynträknare",
    RESET_COINS_COUNT_ALL:"Återställ alla polletträknare",
    RESET_EUROKEY_COUNT_ALL:"Återställ alla Eurokeyräknare",
    FACILITY_DETAILS:"Anläggningsdetaljer",
    FACILITY_NAME:"Anläggningens namn",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Bilden uppladdad",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Du har uppdaterat information ",
    CONNECTED:"Ansluten ",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Meddelandefilter ",
    FACILITY:"Anläggning ",
    APPLY:"Ansök",
    TIME:"Tid",
    LOCATION:"Plats",
    ACKNOWLEDGED:"Bekräftad ",
    FILTERED_MESSAGES:"Filtrerade meddelanden ",
    ACK:"Bekräftad ",
    NOT_ACK:"Ej bekräftad ",
    ALL:"Alla",
    ALL_FACILITIES:"Alla anläggningar ",
    ENTER_DATE_PLACEHOLDER:"Ange datum ",
    OP_NESTANAK_NAPONA:"Spänning saknas på fasindikator 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Brytare Högtryckspump har löst ut",
    OP_UPR_NAPON_24VAC_GRE:"Saknas 24 VAC - brytare 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Färskvattenbehållare tom",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Nätströmbrytaren avslagen",
    OP_MIN_NIVO_OMEKS_VODE:"mjukvattenbehållare tom",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Brytare för mjukvattenpump har löst ut",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosvattenbehållare tom",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Brytare för pump Osmosvatten har löst ut",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Osmosproduktionens pump har löst ut",
    OP_BOJLER_GRESKA_MZS:"Varmvattenelement ur funktion",
    OP_CRPKA_PRASKA_GRE_MZS:"Varmvattenpump har löst ut",
    OP_DOZATOR_PRASKA_GRE_MZS:"Motordrivningsbrytare för pulverdosering har löst ut",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Pulsdoseringsvibratorströmbrytaren har löst ut",
    OP_MIN_PRASAK_TON_ALARM:"Pulverblandningstank tom",
    OP_USIS_KOV_TURBINA_GRESKA:"Myntvakuumturbinalbrytare har löst ut",
    OP_FILTER_VODE_ZACEPLJEN:"vattenfiltret blockerat ",
    OP_VISKTL_RESET_SATI_RADA:"Service av Högtryckspump",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Vattenfilterfel",
    OP_BOJLER_DANI_RADA:"fel på vattenvärmare ",
    OPW_ALARM_VISOKOTL_PUMPA:"Högtryckspumplarm",
    OPW_ALARM_FILTER_SERVIS:"Filterlarm",
    OPW_ALARM_BOJLER_SERVIS:"värmare servicelarm ",
    HAS_MEMBERS:"Den valda gruppen har medlemmar och kan inte raderas. Medlemmar måste raderas först.",
    PERIODIC_SUMMARY_FOR:"PERIODISK SAMMANFATTNINGSRAPPORT FÖR",
    PERIODIC_SUMMARY_REPORTS:"periodiska sammanfattningsrapporter ",
    DATE_RANGE:"Intervall datum",
    FINANCIAL_REPORT:"finansiell rapport ",
    GROSS_INCOME:"Bruttoinkomst",
    GROSS_INCOME_SUM:"Bruttoinkomst summering",
    COMMISSION_FEE:"provisionskostnad",
    NET_INCOME:"Nettoinkomst (för fakturering)",
    COMMISSION_FEE_DETAILS:"Provisionsavgift inkluderar bank- / PayPal-tillhandahållande eller avgift för leverantörer av SMS-tjänster",
    LOYALTY_CREDITS_REPORT:"Rapport för lokala polletter",
    LOYALTY_GIVEN:"givna lokala polletter ",
    LOYALTY_USED:"använda lokala polletter ",
    LOYALTY_SOLD:"lokala polletter laddade ",
    LOYALTY_TOTAL:"totalt ",
    LOYALTY_CURRENT_MONTH:"nuvarande månad ",
    SOMETHING_WENT_WRONG:"oooooops",
    MISSING_PAGE:"förlåt. sidan hittades inte ",
    TRY_AGAIN:"försök igen ",
    DEFAULT_ERROR_NAME:"okänt fel har uppstått ",
    DEFAULT_ERROR_DESCRIPTION:"vänligen försök igen ",
    MY_ACCOUNT_DETAILS:"mitt konto detaljer ",
    SAVE_CHANGES:"spara ändringar ",
    USERNAME:"användarnamn ",
    FIRST_NAME:"namn ",
    LAST_NAME:"efternamn ",
    USER_ROLE:"användarroll ",
    OLD_PASSWORD:"gammalt lösenord ",
    NEW_PASSWORD:"nytt lösenord ",
    OLD_PASSWORD_REQUIRED:"gamla lösenordet krävs ",
    NEW_PASSWORD_REQUIRED:"nya lösenordet krävs ",
    NEW_PASSWORD_REPEAT:"upprepning av nya lösenordet krävs ",
    NEW_PASSWORD_NOT_MATCH:"det gamla och nya lösenordet matchar inte ",
    PASSWORD_DIFFERENT_VALIDATION:"det nya lösenordet måste vara annorlunda jämfört med det gamla ",
    PASSWORD_MIN_CHAR:"lösenordet måste vara minst 8 tecken långt ",
    PASSWORD_MAX_CHAR:"lösenordet får max vara 32 tecken långt ",
    PASSWORD_PATTERN_VALIDATION:"lösenordet måste innehålla minst en siffra ",
    ACCOUNT_MANAGEMENT:"kontoinställningar ",
    NOT_ACTIVE:"inte aktiv ",
    ASSIGN_ROLE:"tilldela roll ",
    UPDATE:"uppdatera ",
    ADD_NEW_ACCOUNT:"lägg till nytt konto ",
    EMAIL_REQUIRED:"e-postadress krävs ",
    EMAIL_NOT_VALID:"e-postadress är ej giltig ",
    ADD_NEW_USER_TEXT:"E-post med aktiveringslänk skickas till den angivna e-postadressen.",
    UPDATE_USER_NOTIFICATION:"informationen har uppdaterats ",
    CHANGED_PASSWORD_NOTIFICATION:"lösenordet har ändrats ",
    UPDATE_USER_GROUP_NOTIFICATION:"gruppnamnet har ändrats ",
    CREATE_USER_GROUP_NOTIFICATION:"grupp har skapats ",
    DETELE_USER_GROUP_NOTIFICATION:"grupp har raderats ",
    EMPTY_GROUP_LIST_MSG:"det finns inga skapade grupper. börja med att skapa en",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"användare togs bort från gruppen ",
    ADD_USER_TO_GROUP_NOTIFICATION:"användare har lagts till i gruppen ",
    ADD_USER_NOTIFICATION:"ny användare lades till i gruppen ",
    DELETE_USER_NOTIFICATION:"användare har raderats ",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"för att skapa en användargrupp ",
    DELETE_USER:"radera användare ",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"är du säker på att du vill radera användare från grupp? ",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Bäste Kärcherappanvändare ",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Lojalitetsregel per antal besök",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Lojalitetsregel per antal använda polletter ",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Lojalitetsregel per dag i veckan ",
    REMOVE_CAMPAIGN_RULE_TITLE:"Borttagning av kampanjregel ",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"är du säker på att du vill ta bort kampanjregel? ",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"ny kampanj har skapats ",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"kampanj har aktiverats ",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"det finns inga skapade kampanjer. börja med att skapa en ",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"meddelandet har skickats ",
    COMPANY_ACCOUNTS:"företagskonton ",
    BUSSINESS_INVOICES_LIST:"min B2B faktura ",
    LOCALE_TOKEN:"lokala polletter ",
    R2W:"globala polletter ",
    START_MONTH:"start på månad",
    END_MONTH:"slut på månad ",
    TOKEN_TYPE:"Pollettyp",
    TOKEN_NUMBER:"Pollettnummer",
    NOTHING_TO_DISPLAY:"* inget att visa",
    CREATE_INVOICE:"skapa faktura ",
    INVOICE:"faktura ",
    INVOICES:"fakturor ",
    EDIT_INVOICE:"redigera faktura ",
    UPDATE_INVOICE_NOTIFICATION:"Du har uppdaterat fakturan till väntande status",
    CURRENT_CHARGES:"Avgifter för den aktuella perioden",
    PAYMENTS_ON_HOLD:"Fakturan bearbetas ",
    FOR_INVOICING:"för fakturering ",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"du kommer avbryta fakturan ",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"är du säker på att du vill avbryta fakturan? ",
    INVOICING_NOTIFICATION_HEADER:"du kommer fakturera",
    INVOICING_NOTIFICATION_TEXT:"är du säker på att du vill skicka faktura? ",
    SENT_INVOICE_NOTIFICATION:"du har skickat fakturan ",
    CANCELED_INVOICE_NOTIFICATION:"du avbröt fakturan ",
    INVOICE_DESCRIPTION_TEXT:"faktura för ",
    INVOICE_STATE:"Status faktura",
    INVOICE_NUMBER:"fakturanummer ",
    INVOICE_TOTAL:"totalt ",
    SELECT_YEAR:"välj år ",
    DOWNLOAD:"ladda ned PDF",
    INVOICE_NUMBER_HEADER:"du kommer skicka faktura med nummer ",
    INVOICE_PAYMENT_CONFIRMATION:"du kommer bekräfta betalning för ",
    INSERT_INVOICE_NUMBER:"Lägg in fakturanummer ",
    INVOICED_WARNING:"Mailen skickades inte. vänligen vänta ",
    SEND_INVOICE:"skicka ",
    INVOICE_ALL:"alla ",
    INVOICE_FROM_R2W:"från R2W",
    INVOICE_TO_R2W:"till R2W",
    PAYMENT_REQUEST:"betalningsbegäran ",
    PAYMENT_REQUEST_STATE:"Status betalningsbegäran ",
    PAYMENT_REQUEST_NUMBER:"Nummer för betalningsbegäran ",
    FOR_PAYMENT_REQUEST:"för betalningsbegäran ",
    PAYMENT_REQUEST_ON_HOLD:"betalningsbegäran bearbetas ",
    DOWNLOAD_INVOICE:"ladda ned faktura ",
    CLICK_FOR_DOWNLOAD_OPTIONS:"klicka för nedladdningsalternativ ",
    B2B_SPEC:"B2B specifikation ",
    B2C_SPEC:"B2C specifikation ",
    DOWNLOAD_PAYMENT_REQUEST:"ladda ned betalningsbegäran ",
    LOYALTY_PREVIEW:"lojalitetsförhandsvisning",
    ACTIVATED:"aktiverad ",
    RUNNING:"pågående ",
    NOT_ACTIVATED:"ej aktiverad ",
    FINISHED:"avslutad ",
    DEPRECATED:"förringa ",
    UPCOMING:"kommande ",
    NONE:"ingen",
    STARTED:"påbörjad ",
    ENDS:"avslutas ",
    DEDICATED:"tillägnad till ",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"du kommer aktivera ",
    CAMPAIGN:"kampanj",
    SEND_MESSAGE_NOTIFICATION:"du kommer skicka meddelande till valda grupper ",
    DIVISIBLE_TO_NUMBER:"numret borde vara delbart med ",
    BRIDGE_PLC:"Bro-PLC",
    DEVICE_TYPE:"enhetstyp",
    LISTENER:"små maskiner ",
    BRIDGE:"Tvättbås",
    WASH_BOXES:"Tvättbås",
    VACUUMS:" Vacuums",
    SAVE_NEWS:"spara nyheter ",
    CREATE_NEW_NEWS:"skapa nya nyheter ",
    HISTORY_OF_ALL_NEWS:"historik över alla nyheter ",
    TYPE_FACILITY_NAME_PLACEHOLDER:"typ anläggningsnamn ",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"lägg till en annan anläggning ",
    NEWS_TEXT:"nyheter text",
    NEWS_TITLE:"nyhetstitel",
    DELETE_NEWS_CONFIRMATION:"du kommer radera nyheter ",
    NEWS_DELETE_NOTIFICATION:"nyheterna har raderats ",
    NEWS_SAVE_NOTIFICATION:"nyheterna har sparats ",
    NEWS_CREATION_DATE:"datum av skapande ",
    NO_TITLE:"ingen titel ",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"nyhetstexten måste vara mindre än 255 tecken lång ",
    NEWS_TEXT_REQUIRED_VALIDATION:"nyhetstext krävs inte ",
    NEWS_TITLE_REQUIRED_VALIDATION:"nyhetstitel krävs ",
    DEACTIVATE:"avaktiverad ",
    ASIDE_MENU_LOCAL_TOKENS:"lokala polletter ",
    CREATE_NEW_LOCAL_TOKENS:"ge ut nya lokala polletter ",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Ange kundens e-postadress och det antal polletter som du vill ge ut till kunden",
    CREATE_TOKENS:"Ge ut polletter ",
    MINIMUM_ONE_TOKEN:"värdet måste vara större än 0",
    CUSTOMER_EMAIL:"kund e-post",
    AMOUNT_OF_TOKENS:"antal polletter ",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Gick bra att ge ut lokala polletter till ",
    PROBLEM_ISSUING_LOCAL_TOKENS:"ett fel uppstod med att ge ut lokala polletter. vänligen kontrollera kundens e-postadress och försök igen",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"översikt av utgivna lokala polletter ",
    ISSUED_AT:"utgiven på",
    ISSUED_BY:"utgiven av ",
    CODE:"inlösningskod ",
    REDEEMED_BY:"löst in av ",
    REDEEMED_AT:"löst in på ",
    ASIDE_MENU_VOUCHERS:"kupong ",
    PRINT:"skriv ut ",
    VOUCHERS_OVERVIEW:"kupongöversikt ",
    CREATE_NEW_VOUCHERS:"skapa ny kupong ",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Skapa en ny inlösningsbar kupongpaket genom att ange antal polletter per kupong",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"antal polletter per kupong ",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Du kan tilldela mellan 1 och 100 polletter per kupong",
    NUMBER_OF_NEW_VOUCHERS:"antal kuponger som ska skapas  ",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Du kan skapa mellan 1 och {{antal}} kuponger i en enda omgång",
    NEW_VOUCHERS_PREFIX:"ny kupongseriekod prefix ",
    VALIDATION_VOUCHER_PREFIX:"kodprefixet måste vara exakt 4 tecken långt (stor bokstav och/eller siffror)",
    PROBLEM_CREATING_NEW_VOUCHERS:"ett problem uppstod med att skapa ny kupong. vänligen försök igen eller kontakta supporten. ",
    CREATE_VOUCHERS:"skapa kupong",
    CREATING_VOUCHERS_SUCCESS:"ny kupong har skapats ",
    PRINT_NEW_VOUCHERS:"skriv ut kupong ",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"ange en kupongseriekod prefix för att skriva ut hela kupongserien. alternativt ",
    PRINT_VOUCHERS_PREFIX:"kupong (serie) kod prefix",
    NO_VOUCHERS_FOR_PRINT:"ingen kupong hittades för att skriva ut som matchade den angivna kod prefixen",
    PRINT_VOUCHERS:"skriv ut kupong ",
    VALIDATION_VOUCHER_CODE_FILTER:"kupongers sökterm måste innehålla stor bokstav och siffror ",
    FILTER_VOUCHERS_BY_CODE:"Sök kuponger genom att lösa in koden",
    FILTER_VOUCHERS:"sök kuponger ",
    WASH_BOX:"Tvättbås",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Totalt använda digitala polletter",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Totalt sålda lokala polletter per datum",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"totalt använda lokala polletter per datum",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"totalt utgivna lokala polletter per datum ",
    LOCAL_TOKEN:"lokala polletter",
    GIVEN_TOKEN:"Utgivna lokala polletter ",
    SOLD_TOKEN:"sålda lokala polletter ",
    SMALL_MACHINES:"små maskiner ",
    R2W_Listener:"lyssnare ",
    HHANLE_DEVICE:"HHanle tvättbås",
    CODE_PREFIX_EXIST:"kodprefix finns redan ",
    CODE_PREFIX_EXIST_TEXT:"Du kan inte skapa en ny kupong med det här kodprefixet. Välj en annan.",
    MIN_FOUR_VALIDATION:"exakt 4 tecken",
    ALL_INFORMATION_1:"all information om",
    ALL_INFORMATION_2:"kommer förloras ",
    ASIDE_MENU_TRANSACTIONS:"transaktion ",
    EXPENSES:"utgifter ",
    TOPUPS:"Påfyllnad",
    EXPENSES_LIST:"utgifter lista ",
    USER_EMAIL:"användarens e-post",
    COMPANY_NAME:"företagsnamn ",
    TOPUPS_LIST:"Påfyllnadslista ",
    CONSUMER:"konsument",
    SYSTEM_ADMIN:"systemadministratör ",
    MERCHANT_ADMIN:"Handlaradministratör",
    COMPANY_ADMIN:"företagsadministratör ",
    FACILITY_ADMIN:"anläggningsadministratör",
    SUBSCRIBER:"prenumerant  ",
    CONFIGURATOR:" konfigurator",
    SETUP_UNIT_SERIAL_NO:"serienummer ",
    SETUP_UNIT_MATERIAL_NO:"Materialnummer",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi version ",
    TOTAL_TURNOVER:"Tvättanläggningens omsättning",
    AVAILABILITY_ALL:"tillgänglighet ",
    AVAILIBILITY:"Tvättbås tillgänglighet ",
    AVAILABILITY_VACUUMS:"Dammsugarnas tillgänglighet ",
    WASH_BOX_INFO:"Tvättbåsens information ",
    VACUUM_CLEANER_INFO:"dammsugare info",
    BREAD_CRUMBS_SERVICE:"tjänst ",
    HOLIDAYS:"semester ",
    LIGHTS_ON:"lampor/på",
    LIGHTS_OFF:"lampor/av",
    WASH_BOXES_ON:"tvättbås/på",
    WASH_BOXES_OFF:"tvättbås/av",
    VACUUMS_ON:"dammsugare/på",
    VACUUMS_OFF:"dammsugare/av",
    TURNOVER:"omsättning ",
    TURNOVER_MANUAL_WASH_UNIT:"omsättning manual ",
    STATUS_BAY_RUN_TIME:"tvättbås total arbetstid ",
    STATUS_BAY_PROGRAM_NAME:"programnamn",
    STATUS_BAY_CREDIT:"tvättbås poäng ",
    CLOUD_KREDIT:"moln poäng ",
    STATUS_VACUUM_RUN_TIME:"dammsugare total arbetstid ",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facilitetstjänster,  program Tvättbås och aktuell feldatainformation",
    UNAVAILABLE:"enhet är tillgänglig ",
    SHOW_HIDE_TABLE:"visa/dölj tabell för arbetstimmar",
    PROGRAM_NAME:"programnamn",
    PROGRAM_OPTION:"programalternativ",
    DEVICE:"enhet",
    QUANTITY:"kvantitet",
    PROGRAM_COUNTER:"programräknare ",
    NO_NAME:"referensen har inget namn ",
    COUNTER_SERVICE_DATA:"tjänstdata ",
    NEED_SERVICE:" Service needed",
    PROGRAM_DATA:"tvättmaskin programdata ",
    CURRENT_FAULT_DATA:"nuvarande fel data ",
    REFERENCE_DUE:"på grund av",
    REFERENCE_SECONDS:"sekunder",
    REFERENCE_NAME:"delnamn",
    WASHBOX_NAME:"Tvättbås namn ",
    FAULT_NAME:"fel namn ",
    FAULT_NUMBER:"fel nummer ",
    CURRENT_FAULT_COUNT:"aktiva fel ",
    DEVICE_NOT_INSTALLED:"enheten ej installerad",
    STATUS_READY:"Status redo",
    STATUS_ERROR:"fel status ",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Mjukvarufel",
    SOFTWARE_RESET:"Mjukvarufel",
    EXTERNAL_PIN_RESET:" Software error",
    RESTART_OR_BROWNOUT_OCCURRED:"Mjukvarufel",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hårdvarufel",
    COULD_NOT_SIMULATE_COIN:"Hårdvarufel",
    ERROR_SETTING_INHIBIT_MODE:"Hårdvarufel",
    OFFLINE_DEVICE:"Fordonstvätt Offline",
    TARIFFS:"Tariffer",
    DAY:"Dag ",
    NIGHT:"Natt",
    VOUCHER_CODE:" Voucher code",
    DISMISS_ALARM:" Reset alarm?",
    ALARM_ACTIVE:" Active alarms",
    NO_ALARM_ACTIVE:" There are no active alarms",
    ALARM_HISTORY:" Alert history",
    MANAGING_TOKENS:"Hantera tokens",
    EXPIRATION_DATE:"Utgångsdatum",
    EXTEND_TOKEN_DATE:"Förläng tokens utgångsdatum för",
    DELETE_TOKENS_FOR:"Ta bort tokens för",
    PUMP_TYPE:"Pump type",
    TURN_OFF_DEVICE:" Device status",
    OPERATION_DATA:" Operation data",
    PUMP_DATA:" Pump data",
    PUMP_NAME:" Pump name",
    POINT_NAME:" Point name",
    CHANGER_INCOME:" Total changer income by date",
    SELECTED_OPEN:"Öppet på valda arbetstider",
    ALWAYS_OPEN:"Alltid öppet (24/7)",
    CLOSED:"Stängd",
    MON:"Måndag",
    TUE:"Tisdag",
    WED:"Onsdag",
    THU:"Torsdag",
    FRI:"Fredag",
    SAT:"Lördag",
    SUN:"Söndag",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Elektroniska utgångar överbelastade",
    KARCHER_ERROR_MESSAGE_2:"oljeavskiljaren måste tömmas",
    KARCHER_ERROR_MESSAGE_4:"Dimningssensor defekt",
    KARCHER_ERROR_MESSAGE_5:"Den skyddande motoromkopplaren på högtryckspumpar startades",
    KARCHER_ERROR_MESSAGE_6:"kopplingen till RDS defekt ",
    KARCHER_ERROR_MESSAGE_7:"Tryckomkopplaren för luft på kompressorn rapporterar inget",
    KARCHER_ERROR_MESSAGE_8:"orsak: ingen koppling till elektroniken 'MSWS'",
    KARCHER_ERROR_MESSAGE_10:"Ingen anslutning till pumpelektronik på tvättstationen 1",
    KARCHER_ERROR_MESSAGE_11:"Elektroniska utgångar vid tvättstation 1 överbelastad",
    KARCHER_ERROR_MESSAGE_12:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 1 för hög",
    KARCHER_ERROR_MESSAGE_13:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 1 för låg",
    KARCHER_ERROR_MESSAGE_14:"Kontakt med högtryckspumpen vid tvättstationen 1 fast",
    KARCHER_ERROR_MESSAGE_15:"semiventil på tvättstationen 1 defekt",
    KARCHER_ERROR_MESSAGE_16:"skyddskontakt för tvättstationen för högtryckspump 1",
    KARCHER_ERROR_MESSAGE_17:"Högtryckspumpens oljenivå vid tvättstationen 1 för låg",
    KARCHER_ERROR_MESSAGE_18:"Elektroniken vid tvättstation 1 defekt",
    KARCHER_ERROR_MESSAGE_19:"Tvättstation 1 för högtryckspumpar motorskyddsbrytare har löst ut",
    KARCHER_ERROR_MESSAGE_20:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 1",
    KARCHER_ERROR_MESSAGE_21:"Fel vid myntacceptorn vid tvättstationen 1",
    KARCHER_ERROR_MESSAGE_22:"Fel vid myntacceptorn vid tvättstationen 1",
    KARCHER_ERROR_MESSAGE_30:"Ingen anslutning till pumpelektronik på tvättstation 2",
    KARCHER_ERROR_MESSAGE_31:"Elektroniska utgångar vid tvättstation 2 överbelastad",
    KARCHER_ERROR_MESSAGE_32:"Aktuell upphämtning av högtryckspumpen vid tvättstation 2 för hög",
    KARCHER_ERROR_MESSAGE_33:"Aktuell upphämtning av högtryckspumpen vid tvättstation 2 för låg",
    KARCHER_ERROR_MESSAGE_34:"Kontakt med högtryckspumpen vid tvättstationen 2 fastnat",
    KARCHER_ERROR_MESSAGE_35:"Semiventil på tvättstation 2 defekt",
    KARCHER_ERROR_MESSAGE_36:"skyddskontakt för tvättstationen för högtryckspump 2",
    KARCHER_ERROR_MESSAGE_37:"Högtryckspumpens oljenivå vid tvättstationen 2 för låg",
    KARCHER_ERROR_MESSAGE_38:"Elektroniken på tvättstationen 2 defekt",
    KARCHER_ERROR_MESSAGE_39:"Tvättstation 2 för motorströmbrytare för högtryckspump har löst ut",
    KARCHER_ERROR_MESSAGE_40:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 2",
    KARCHER_ERROR_MESSAGE_41:"Fel vid myntacceptorn vid tvättstationen 2",
    KARCHER_ERROR_MESSAGE_42:"Fel vid myntacceptorn vid tvättstationen 2",
    KARCHER_ERROR_MESSAGE_50:"Ingen anslutning till pumpelektronik på tvättstationen 3",
    KARCHER_ERROR_MESSAGE_51:"Elektroniska uttag vid tvättstation 3 överbelastad",
    KARCHER_ERROR_MESSAGE_52:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 3 för hög",
    KARCHER_ERROR_MESSAGE_53:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 3 för låg",
    KARCHER_ERROR_MESSAGE_54:"Kontakt med högtryckspumpen vid tvättstationen 3 fastnat",
    KARCHER_ERROR_MESSAGE_55:"Semiventil på tvättstationen 3 defekt",
    KARCHER_ERROR_MESSAGE_56:"skyddskontakt för tvättstation för högtryckspump 3",
    KARCHER_ERROR_MESSAGE_57:"Oljenivån för högtryckspumpen vid tvättstationen 3 för låg",
    KARCHER_ERROR_MESSAGE_58:"Elektroniken på tvättstationen 3 defekt",
    KARCHER_ERROR_MESSAGE_59:"Tvättstation 3 för motorströmbrytare för högtryckspump har utlösts",
    KARCHER_ERROR_MESSAGE_60:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 3",
    KARCHER_ERROR_MESSAGE_61:"Fel vid myntacceptorn vid tvättstationen 3",
    KARCHER_ERROR_MESSAGE_62:"Fel vid myntacceptorn vid tvättstationen 3",
    KARCHER_ERROR_MESSAGE_70:"Ingen anslutning till pumpelektronik på tvättstationen 4",
    KARCHER_ERROR_MESSAGE_71:"Elektroniska utgångar vid tvättstation 4 överbelastad",
    KARCHER_ERROR_MESSAGE_72:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 4 för hög",
    KARCHER_ERROR_MESSAGE_73:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 4 för låg",
    KARCHER_ERROR_MESSAGE_74:"Kontakt med högtryckspump vid tvättstationen 4 fastnat",
    KARCHER_ERROR_MESSAGE_75:"semiventil på tvättstationen 4 defekt",
    KARCHER_ERROR_MESSAGE_76:"skyddskontakt för tvättstation för högtryckspump 4",
    KARCHER_ERROR_MESSAGE_77:"Högtryckspumpens oljenivå vid tvättstationen 4 för låg",
    KARCHER_ERROR_MESSAGE_78:"Elektroniken på tvättstationen 4 defekt",
    KARCHER_ERROR_MESSAGE_79:"Tvättstation 4 för högtryckspumpar för motorströmbrytare har utlösts",
    KARCHER_ERROR_MESSAGE_80:"Ingen anslutning till pumpelektronik på tvättstationen 4",
    KARCHER_ERROR_MESSAGE_81:"Fel vid myntacceptorn vid tvättstationen 4",
    KARCHER_ERROR_MESSAGE_82:"Fel vid myntacceptorn vid tvättstationen 4",
    KARCHER_ERROR_MESSAGE_90:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 5",
    KARCHER_ERROR_MESSAGE_91:"Elektroniska utgångar vid tvättstation 5 överbelastad",
    KARCHER_ERROR_MESSAGE_92:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 5 för hög",
    KARCHER_ERROR_MESSAGE_93:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 5 för låg",
    KARCHER_ERROR_MESSAGE_94:"Kontakt med högtryckspumpen vid tvättstationen 5 fastnat",
    KARCHER_ERROR_MESSAGE_95:"Semiventil på tvättstationen 5 defekt",
    KARCHER_ERROR_MESSAGE_96:"skyddskontakt för tvättstationen för högtryckspump 5",
    KARCHER_ERROR_MESSAGE_97:"Högtryckspumpens oljenivå vid tvättstationen 5 för låg",
    KARCHER_ERROR_MESSAGE_98:"Elektroniken vid tvättstation 5 defekt",
    KARCHER_ERROR_MESSAGE_99:"Tvättstation 5 för högtryckspumpar för motorströmbrytare har utlösts",
    KARCHER_ERROR_MESSAGE_100:"Ingen anslutning till pumpelektronik på tvättstationen 5",
    KARCHER_ERROR_MESSAGE_101:"Fel vid myntacceptorn vid tvättstationen 5",
    KARCHER_ERROR_MESSAGE_102:"Fel vid myntacceptorn vid tvättstationen 5",
    KARCHER_ERROR_MESSAGE_110:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 6",
    KARCHER_ERROR_MESSAGE_111:"Elektroniska utgångar vid tvättstation 6 överbelastad",
    KARCHER_ERROR_MESSAGE_112:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 6 för hög",
    KARCHER_ERROR_MESSAGE_113:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 6 för låg",
    KARCHER_ERROR_MESSAGE_114:"Kontakt med högtryckspumpen vid tvättstationen 6 fastnat",
    KARCHER_ERROR_MESSAGE_115:"Semiventil på tvättstationen 6 defekt",
    KARCHER_ERROR_MESSAGE_116:"skyddskontakt för tvättstationen för högtryckspump 6",
    KARCHER_ERROR_MESSAGE_117:"Högtryckspumpens oljenivå vid tvättstationen 6 för låg",
    KARCHER_ERROR_MESSAGE_118:"Elektroniken vid tvättstation 6 defekt",
    KARCHER_ERROR_MESSAGE_119:"Tvättstation 6 för högtryckspumpar för motorströmbrytare har utlösts",
    KARCHER_ERROR_MESSAGE_120:"Ingen anslutning till pumpelektronik på tvättstationen 6",
    KARCHER_ERROR_MESSAGE_121:"Fel vid myntacceptorn vid tvättstationen 6",
    KARCHER_ERROR_MESSAGE_122:"Fel vid myntacceptorn vid tvättstationen 6",
    KARCHER_ERROR_MESSAGE_130:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 7",
    KARCHER_ERROR_MESSAGE_131:"Elektroniska utgångar vid tvättstation 7 överbelastad",
    KARCHER_ERROR_MESSAGE_132:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 7 för hög",
    KARCHER_ERROR_MESSAGE_133:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 7 för låg",
    KARCHER_ERROR_MESSAGE_134:"Kontakt med högtryckspumpen vid tvättstationen 7 fastnat",
    KARCHER_ERROR_MESSAGE_135:"Semiventil på tvättstationen 7 defekt",
    KARCHER_ERROR_MESSAGE_136:"skyddskontakt för tvättstationen för högtryckspump 7",
    KARCHER_ERROR_MESSAGE_137:"Högtryckspumpens oljenivå vid tvättstationen 7 för låg",
    KARCHER_ERROR_MESSAGE_138:"Elektroniken vid tvättstation 7 defekt",
    KARCHER_ERROR_MESSAGE_139:"Tvättstation 7 för högtryckspumpar för motorströmbrytare har utlösts",
    KARCHER_ERROR_MESSAGE_140:"Ingen anslutning till pumpelektronik på tvättstationen 7",
    KARCHER_ERROR_MESSAGE_141:"Fel vid myntacceptorn vid tvättstationen 7",
    KARCHER_ERROR_MESSAGE_142:"Fel vid myntacceptorn vid tvättstationen 7",
    KARCHER_ERROR_MESSAGE_150:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 8",
    KARCHER_ERROR_MESSAGE_151:"Elektroniska ugångar vid tvättstation 8 överbelastad",
    KARCHER_ERROR_MESSAGE_152:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 8 för hög",
    KARCHER_ERROR_MESSAGE_153:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 8 för låg",
    KARCHER_ERROR_MESSAGE_154:"Kontakt med högtryckspumpen vid tvättstationen 8 fastnat",
    KARCHER_ERROR_MESSAGE_155:"Semiventil på tvättstationen 8 defekt",
    KARCHER_ERROR_MESSAGE_156:"skyddskontakt för tvättstationen för högtryckspump 8",
    KARCHER_ERROR_MESSAGE_157:"Oljenivån för högtryckspumpen vid tvättstationen 8 för låg",
    KARCHER_ERROR_MESSAGE_158:"Elektroniken på tvättstationen 8 defekt",
    KARCHER_ERROR_MESSAGE_159:"Tvättstationen 8 för motorströmbrytare för högtryckspump har utlösts",
    KARCHER_ERROR_MESSAGE_160:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 8",
    KARCHER_ERROR_MESSAGE_161:"Fel vid myntacceptor vid tvättstationen 8",
    KARCHER_ERROR_MESSAGE_162:"Fel vid myntacceptor vid tvättstationen 8",
    KARCHER_ERROR_MESSAGE_170:"ingen anslutning till elektroniken A2",
    KARCHER_ERROR_MESSAGE_171:"Utgångarna på elektroniken A2 överbelastad",
    KARCHER_ERROR_MESSAGE_172:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_173:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_174:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_175:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_176:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_177:"Den aktuella uppsamlingen av pumpens undervattentvätt för hög",
    KARCHER_ERROR_MESSAGE_178:"Inget tryck efter påslagning av underspolningen",
    KARCHER_ERROR_MESSAGE_190:"ingen anslutning till elektroniken A3",
    KARCHER_ERROR_MESSAGE_191:"Elektronikens A3-utgångar överbelastade",
    KARCHER_ERROR_MESSAGE_200:"Ingen koppling mellan styrning och elektronik från WSO",
    KARCHER_ERROR_MESSAGE_201:"Utgångar WSO överbelastade  ",
    KARCHER_ERROR_MESSAGE_202:"Hårdhetssensorn visar hårt vatten efter regenerering",
    KARCHER_ERROR_MESSAGE_204:"Elektronikfel",
    KARCHER_ERROR_MESSAGE_210:"Nivåsensor BUFFERTTANK TOM aktiverad",
    KARCHER_ERROR_MESSAGE_211:"Nivåsensor BUFFERTTANK TOM och BUFFERTTANK FULL-påverkade samtidigt",
    KARCHER_ERROR_MESSAGE_212:"Nivåsensor RO PUMP ON och BUFFER CONTAINER FULL-påverkade samtidigt",
    KARCHER_ERROR_MESSAGE_213:"ingen vattentryck",
    KARCHER_ERROR_MESSAGE_214:"Vattenmatningen  rapporterar fel",
    KARCHER_ERROR_MESSAGE_220:"för lite vatten ",
    KARCHER_ERROR_MESSAGE_221:"Avgasstemperaturen är för hög",
    KARCHER_ERROR_MESSAGE_222:"Aktuell uppsamling av cirkulationspumpen för varmt vatten för högt",
    KARCHER_ERROR_MESSAGE_223:"fel på brännare ",
    KARCHER_ERROR_MESSAGE_224:"Säkerhetstermostat oljebrännare är påverkad",
    KARCHER_ERROR_MESSAGE_225:"Fördröjning brännare aktiv",
    KARCHER_ERROR_MESSAGE_226:"Flödesindikator öppnade ej inom 5 sek efter att cirkulationspumpen för varmvattnet stängde av",
    KARCHER_ERROR_MESSAGE_227:"Flödesindikator stängde ej inom 3 sek efter att cirkulationspumpen för varmvattnet stängdes av",
    KARCHER_ERROR_MESSAGE_228:"Utgång för Varmvatten kyls av för sakta efter att brännaren stängts av",
    KARCHER_ERROR_MESSAGE_229:"Felkod tempgivare varmvatten",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Förnyelse av basbyten avslutad",
    KARCHER_INFO_MESSAGE_3:"Basväxlaren tappade 75%",
    KARCHER_INFO_MESSAGE_4:"enheten inte tillgänglig på grund av tekniskt fel",
    KARCHER_INFO_MESSAGE_5:"Enheten inte tillgänglig på grund av driftsproblem",
    KARCHER_INFO_MESSAGE_6:"enhet på",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bås 1 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_12:"Bås 2 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_13:"Bås 3 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_14:"Bås 4 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_15:"Bås 5 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_16:"Bås 6 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_17:"Bås 7 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_18:"Bås 8 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella-program för varmt vatten",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella-program HD-pump 1 krävs",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella-program HD-pump 2 krävs",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella-program HD-pump 3 krävs",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella-program HD-pump 4 krävs",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella-program HD-pump 5 krävs",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella-program HD-pump 6 krävs",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella-program HD-pump 7 krävs",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella-program HD-pump 8 krävs",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella-program färdig ",
    KARCHER_INFO_MESSAGE_101:"Högtryckspump 1 dags för service ",
    KARCHER_INFO_MESSAGE_102:"Högtryckspump 2 dags för service ",
    KARCHER_INFO_MESSAGE_103:"Högtryckspump 3 dags för service ",
    KARCHER_INFO_MESSAGE_104:"Högtryckspump 4 dags för service ",
    KARCHER_INFO_MESSAGE_105:"Högtryckspump 5 dags för service ",
    KARCHER_INFO_MESSAGE_106:"Högtryckspump 6 dags för service ",
    KARCHER_INFO_MESSAGE_107:"Högtryckspump 7 dags för service ",
    KARCHER_INFO_MESSAGE_108:"Högtryckspump 8 dags för service ",
    KARCHER_INFO_MESSAGE_109:"brännare dags att dags för service ",
    KARCHER_INFO_MESSAGE_110:"brännarfläkt dags för service ",
    KARCHER_INFO_MESSAGE_111:"varmvattenpump dags för service ",
    KARCHER_INFO_MESSAGE_112:"frostskyddspump dags för service   ",
    KARCHER_INFO_MESSAGE_113:"osmospump dags för service ",
    KARCHER_INFO_MESSAGE_114:"golvvärmare dags för service ",
    KARCHER_INFO_MESSAGE_115:"rörvärmare dags för service  ",
    KARCHER_INFO_MESSAGE_116:"Pump för mikroemulsion / fälgstädning dags för service ",
    KARCHER_INFO_MESSAGE_117:"Rengöringspump för undervagn dags för service ",
    KARCHER_INFO_MESSAGE_118:"trycksystempump dags för service ",
    KARCHER_INFO_MESSAGE_119:"Dammsugare 1 dags för service ",
    KARCHER_INFO_MESSAGE_120:"Dammsugare 2 dags för service ",
    KARCHER_INFO_MESSAGE_121:"Dammsugare 3 dags för service ",
    KARCHER_INFO_MESSAGE_122:"Dammsugare 4 dags för service ",
    KARCHER_INFO_MESSAGE_123:"Dammsugare 5 dags för service ",
    KARCHER_INFO_MESSAGE_124:"Dammsugare 6 dags för service ",
    KARCHER_INFO_MESSAGE_125:"Dammsugare 7 dags för service ",
    KARCHER_INFO_MESSAGE_126:"Dammsugare 8 dags för service ",
    KARCHER_INFO_MESSAGE_127:"Dammsugare 9 dags för service ",
    KARCHER_INFO_MESSAGE_128:"Dammsugare 10 dags för service ",
    KARCHER_INFO_MESSAGE_129:"Dammsugare 11 dags för service ",
    KARCHER_INFO_MESSAGE_130:"Dammsugare 12 dags för service ",
    KARCHER_INFO_MESSAGE_131:"Rengöringsmedelspump dags för service ",
    KARCHER_INFO_MESSAGE_132:"Mikroemulsionspump dags för service ",
    KARCHER_INFO_MESSAGE_133:"Intensiv skumpump dags för service ",
    KARCHER_INFO_MESSAGE_142:"Dammsugare 1-turbin dags för service ",
    KARCHER_INFO_MESSAGE_143:"Dammsugare 1-filter dags för service ",
    KARCHER_INFO_MESSAGE_144:"Dammsugare 2-turbin dags för service ",
    KARCHER_INFO_MESSAGE_145:"Dammsugare 2-filter dags för service ",
    KARCHER_INFO_MESSAGE_146:"Dammsugare 3-turbin dags för service ",
    KARCHER_INFO_MESSAGE_147:"Dammsugare 3-filter dags för service ",
    KARCHER_INFO_MESSAGE_148:"Dammsugare 4-turbin dags för service ",
    KARCHER_INFO_MESSAGE_149:"Dammsugare 4-filter dags för service ",
    KARCHER_INFO_MESSAGE_150:"Dammsugare 5-turbin dags för service ",
    KARCHER_INFO_MESSAGE_151:"Dammsugare 5-filter dags för service ",
    KARCHER_INFO_MESSAGE_152:"Dammsugare 6-turbin dags för service ",
    KARCHER_INFO_MESSAGE_153:"Dammsugare 6-filter dags för service ",
    KARCHER_INFO_MESSAGE_154:"Dammsugare 7-turbin dags för service ",
    KARCHER_INFO_MESSAGE_155:"Dammsugare 7-filter dags för service ",
    KARCHER_INFO_MESSAGE_156:"Dammsugare 8-turbin dags för service ",
    KARCHER_INFO_MESSAGE_157:"Dammsugare 8-filter dags för service ",
    KARCHER_INFO_MESSAGE_158:"Dammsugare 9-turbin dags för service ",
    KARCHER_INFO_MESSAGE_159:"Dammsugare 9-filter dags för service ",
    KARCHER_INFO_MESSAGE_160:"Dammsugare 10-turbin dags för service ",
    KARCHER_INFO_MESSAGE_161:"Dammsugare 10-filter dags för service ",
    KARCHER_INFO_MESSAGE_162:"Dammsugare 11-turbin dags för service ",
    KARCHER_INFO_MESSAGE_163:"Dammsugare 11-filter dags för service ",
    KARCHER_INFO_MESSAGE_164:"Dammsugare 12-turbin dags för service ",
    KARCHER_INFO_MESSAGE_165:"Dammsugare 12-filter dags för service ",
    SITE_DETAILS_SUCCESSFULLY_UPDATED: "Site details successfully updated",
    COMPANY: "Company",
    FACILITY_HAS_CHANGER: "Have changer?",
    DISABLE_OFFLINE_ALARM: "Disable R2W alarms",
    ASIDE_WORKING_SCHEDULES: "App Site details",
    TERMS_OF_SERVICE_R2W_TITLE: "Ready2Wash terms of service",
    TERMS_OF_SERVICE_R2W: "Ready2Wash terms of service",
    DATA_PROCESSING_TITLE: "Data Processed",
    PRIVACY_POLICY_TITLE: "Privacy Policy",
    READY_TO_PAY_TERMS_OF_SERVICE: "Ready2Pay Terms of service",
    TERMS_AND_SERVICES: "Terms and services",
    INFO_TITLE: "Info",
    HOURLY: "Varje timme",
    DAILY: "Dagligen",
    WEEKLY: "Veckovis",
    MONTHLY: "Månadsvis",
    YEARLY: "Årligen",
    DELETE_ITEM_SUCCESS:"Du har framgångsrikt raderat objektet",
    STATE: "Status",
    AVAILABILITY_STATUS_1: "Enhet öppen",
    AVAILABILITY_STATUS_2: "Enhet stängd (semester)",
    AVAILABILITY_STATUS_3: "Enhet stängd (öppettider)",
    AVAILABILITY_STATUS_4: "Enhet stängd (fel)",
    AVAILABILITY_STATUS_5: "Enhet stängd (annat)",
    AVAILABILITY_VACUUMS_STATUS_1: "Dammsugare ej installerade",
    AVAILABILITY_VACUUMS_STATUS_2: "Dammsugare öppna",
    AVAILABILITY_VACUUMS_STATUS_3: "Dammsugare stängda (semester)",
    AVAILABILITY_VACUUMS_STATUS_4: "Dammsugare stängda (öppettider)",
    AVAILABILITY_VACUUMS_STATUS_5: "Dammsugare stängda (fel)",
    AVAILABILITY_VACUUMS_STATUS_6: "Dammsugare stängda (annat)",
    ECOM_AMOUNT: "Total Ecom för alla platser",
    CAPTURED: "Registrerad",
    G0:"{{brand === 'r2w' ? 'Bay 0' : 'Bay 1'}}",
    G1:"{{brand === 'r2w' ? 'Bay 1' : 'Bay 2'}}",
    G2:"{{brand === 'r2w' ? 'Bay 2' : 'Bay 3'}}",
    G3:"{{brand === 'r2w' ? 'Bay 3' : 'Bay 4'}}",
    G4:"{{brand === 'r2w' ? 'Bay 4' : 'Bay 5'}}",
    G5:"{{brand === 'r2w' ? 'Bay 5' : 'Bay 6'}}",
    G6:"{{brand === 'r2w' ? 'Bay 6' : 'Bay 7'}}",
    G7:"{{brand === 'r2w' ? 'Bay 7' : 'Bay 8'}}",
    G8:"{{brand === 'r2w' ? 'Bay 8' : 'Bay 9'}}",
    G9:"{{brand === 'r2w' ? 'Bay 9' : 'Bay 10'}}",
    G10:"{{brand === 'r2w' ? 'Bay 10' : 'Bay 11'}}",
    U0:"{{brand === 'r2w' ? 'Vacuum 0' : 'Vacuum 1'}}",
    U1:"{{brand === 'r2w' ? 'Vacuum 1' : 'Vacuum 2'}}",
    U2:"{{brand === 'r2w' ? 'Vacuum 2' : 'Vacuum 3'}}",
    U3:"{{brand === 'r2w' ? 'Vacuum 3' : 'Vacuum 4'}}",
    U4:"{{brand === 'r2w' ? 'Vacuum 4' : 'Vacuum 5'}}",
    U5:"{{brand === 'r2w' ? 'Vacuum 5' : 'Vacuum 6'}}",
    U6:"{{brand === 'r2w' ? 'Vacuum 6' : 'Vacuum 7'}}",
    U7:"{{brand === 'r2w' ? 'Vacuum 7' : 'Vacuum 8'}}",
    DELETE_COMPANY_HISTORY_INFO:"Denna åtgärd kommer att ta bort all rapportdata från ditt företag. Denna åtgärd kan inte ångras.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Är du säker på att du vill permanent radera all rapportdata?",
    VALUE_DATE: "Valutadag",
    KARCHER_EVENT_NAME_1: "Huvudvärmeväxlare regenererad",
    KARCHER_EVENT_NAME_2: "Regenerering av huvudvärmeväxlare slutförd",
    KARCHER_EVENT_NAME_3: "Material / serienummer",
    KARCHER_EVENT_NAME_4: "Systemet har desinficerats",
    KARCHER_EVENT_NAME_5: "HP-pump 1 desinficerad",
    KARCHER_EVENT_NAME_6: "HP-pump 2 desinficerad",
    KARCHER_EVENT_NAME_7: "HP-pump 3 desinficerad",
    KARCHER_EVENT_NAME_8: "HP-pump 4 desinficerad",
    KARCHER_EVENT_NAME_9: "HP-pump 5 desinficerad",
    KARCHER_EVENT_NAME_10: "Tvättstation 1 låst",
    KARCHER_EVENT_NAME_11: "Tvättstation 2 låst",
    KARCHER_EVENT_NAME_12: "Tvättstation 3 låst",
    KARCHER_EVENT_NAME_13: "Tvättstation 4 låst",
    KARCHER_EVENT_NAME_14: "Tvättstation 5 låst",
    KARCHER_EVENT_NAME_15: "Tvättstation 6 låst",
    KARCHER_EVENT_NAME_16: "Tvättstation 7 låst",
    KARCHER_EVENT_NAME_17: "Tvättstation 8 låst",
    KARCHER_EVENT_NAME_18: "Uppdatering startad",
    KARCHER_EVENT_NAME_19: "Uppdatering slutförd",
    KARCHER_EVENT_NAME_20: "Start av WS Reg",
    KARCHER_EVENT_NAME_21: "Avslutning av WS Reg",
    KARCHER_EVENT_NAME_22: "WS-sensor 75%",
    KARCHER_EVENT_NAME_23: "Tekniskt fel",
    KARCHER_EVENT_NAME_24: "Driftfel",
    KARCHER_EVENT_NAME_25: "Enhet aktiverad",
    KARCHER_EVENT_NAME_26: "Enhet avstängd",
    KARCHER_EVENT_NAME_27: "Box 1 stängd",
    KARCHER_EVENT_NAME_28: "Box 2 stängd",
    KARCHER_EVENT_NAME_29: "Box 3 stängd",
    KARCHER_EVENT_NAME_30: "Box 4 stängd",
    KARCHER_EVENT_NAME_31: "Box 5 stängd",
    KARCHER_EVENT_NAME_32: "Box 6 stängd",
    KARCHER_EVENT_NAME_33: "Box 7 stängd",
    KARCHER_EVENT_NAME_34: "Box 8 stängd",
    KARCHER_EVENT_NAME_35: "HP-pumpstation 1",
    KARCHER_EVENT_NAME_36: "HP-pumpstation 2",
    KARCHER_EVENT_NAME_37: "HP-pumpstation 3",
    KARCHER_EVENT_NAME_38: "HP-pumpstation 4",
    KARCHER_EVENT_NAME_39: "HP-pumpstation 5",
    KARCHER_EVENT_NAME_40: "HP-pumpstation 6",
    KARCHER_EVENT_NAME_41: "HP-pumpstation 7",
    KARCHER_EVENT_NAME_42: "HP-pumpstation 8",
    KARCHER_EVENT_NAME_43: "Brännare",
    KARCHER_EVENT_NAME_44: "Brännarfläkt",
    KARCHER_EVENT_NAME_45: "Varmvattenpump",
    KARCHER_EVENT_NAME_46: "Frostskyddspump",
    KARCHER_EVENT_NAME_47: "Osmospump",
    KARCHER_EVENT_NAME_48: "Golvvärme",
    KARCHER_EVENT_NAME_49: "Slangvärme",
    KARCHER_EVENT_NAME_50: "Mikro-/hjultvätt",
    KARCHER_EVENT_NAME_51: "Chassitvättpump",
    KARCHER_EVENT_NAME_52: "Booster-skumpump",
    KARCHER_EVENT_NAME_53: "Dammsugare 1",
    KARCHER_EVENT_NAME_54: "Dammsugare 2",
    KARCHER_EVENT_NAME_55: "Dammsugare 3",
    KARCHER_EVENT_NAME_56: "Dammsugare 4",
    KARCHER_EVENT_NAME_57: "Dammsugare 5",
    KARCHER_EVENT_NAME_58: "Dammsugare 6",
    KARCHER_EVENT_NAME_59: "Dammsugare 7",
    KARCHER_EVENT_NAME_60: "Dammsugare 8",
    KARCHER_EVENT_NAME_61: "Dammsugare 9",
    KARCHER_EVENT_NAME_62: "Dammsugare 10",
    KARCHER_EVENT_NAME_63: "Dammsugare 11",
    KARCHER_EVENT_NAME_64: "Dammsugare 12",
    KARCHER_EVENT_NAME_65: "Hjultvättpump",
    KARCHER_EVENT_NAME_66: "Mikropump",
    KARCHER_EVENT_NAME_67: "Intensivpump",
    KARCHER_EVENT_NAME_68: "Dammsugarturbin 1",
    KARCHER_EVENT_NAME_69: "Dammsugarfilter 1",
    KARCHER_EVENT_NAME_70: "Dammsugarturbin 2",
    KARCHER_EVENT_NAME_71: "Dammsugarfilter 2",
    KARCHER_EVENT_NAME_72: "Dammsugarturbin 3",
    KARCHER_EVENT_NAME_73: "Dammsugarfilter 3",
    KARCHER_EVENT_NAME_74: "Dammsugarturbin 4",
    KARCHER_EVENT_NAME_75: "Dammsugarfilter 4",
    KARCHER_EVENT_NAME_76: "Dammsugarturbin 5",
    KARCHER_EVENT_NAME_77: "Dammsugarfilter 5",
    KARCHER_EVENT_NAME_78: "Dammsugarturbin 6",
    KARCHER_EVENT_NAME_79: "Dammsugarfilter 6",
    KARCHER_EVENT_NAME_80: "Dammsugarturbin 7",
    KARCHER_EVENT_NAME_81: "Dammsugarfilter 7",
    KARCHER_EVENT_NAME_82: "Dammsugarturbin 8",
    KARCHER_EVENT_NAME_83: "Dammsugarfilter 8",
    KARCHER_EVENT_NAME_84: "Dammsugarturbin 9",
    KARCHER_EVENT_NAME_85: "Dammsugarfilter 9",
    KARCHER_EVENT_NAME_86: "Dammsugarturbin 10",
    KARCHER_EVENT_NAME_87: "Dammsugarfilter 10",
    KARCHER_EVENT_NAME_88: "Dammsugarturbin 11",
    KARCHER_EVENT_NAME_89: "Dammsugarfilter 11",
    KARCHER_EVENT_NAME_90: "Dammsugarturbin 12",
    KARCHER_EVENT_NAME_91: "Dammsugarfilter 12",
    INSERT_TOKEN: "Ange token och starta tjänsten",
    OPEN_SESSION: "Sessionen har öppnats framgångsrikt",
    IN_PROGRESS: "Pågår ...",
    TOKEN_INSERTED: "Token har lagts till framgångsrikt",
    EXPIRED_SESSION: "Sessionen har löpt ut",
    TWO_DIGIT_INTEGER_VALIDATION: "Använd ett heltal med högst två siffror",
    KARCHER_OPERATION_COUNTER_1: "Tvättstation 1 HP-pump",
    KARCHER_OPERATION_COUNTER_2: "Tvättstation 1 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_3: "Tvättstation 1 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_4: "Tvättstation 1 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_5: "Tvättstation 1 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_6: "Tvättstation 2 HP-pump",
    KARCHER_OPERATION_COUNTER_7: "Tvättstation 2 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_8: "Tvättstation 2 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_9: "Tvättstation 2 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_10: "Tvättstation 2 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_11: "Tvättstation 3 HP-pump",
    KARCHER_OPERATION_COUNTER_12: "Tvättstation 3 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_13: "Tvättstation 3 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_14: "Tvättstation 3 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_15: "Tvättstation 3 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_16: "Tvättstation 4 HP-pump",
    KARCHER_OPERATION_COUNTER_17: "Tvättstation 4 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_18: "Tvättstation 4 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_19: "Tvättstation 4 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_20: "Tvättstation 4 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_21: "Tvättstation 5 HP-pump",
    KARCHER_OPERATION_COUNTER_22: "Tvättstation 5 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_23: "Tvättstation 5 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_24: "Tvättstation 5 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_25: "Tvättstation 5 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_26: "Tvättstation 6 HP-pump",
    KARCHER_OPERATION_COUNTER_27: "Tvättstation 6 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_28: "Tvättstation 6 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_29: "Tvättstation 6 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_30: "Tvättstation 6 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_31: "Tvättstation 7 HP-pump",
    KARCHER_OPERATION_COUNTER_32: "Tvättstation 7 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_33: "Tvättstation 7 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_34: "Tvättstation 7 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_35: "Tvättstation 7 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_36: "Tvättstation 8 HP-pump",
    KARCHER_OPERATION_COUNTER_37: "Tvättstation 8 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_38: "Tvättstation 8 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_39: "Tvättstation 8 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_40: "Tvättstation 8 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_41: "Osmospump",
    KARCHER_OPERATION_COUNTER_42: "Varmvattenberedare",
    KARCHER_OPERATION_COUNTER_43: "Frostskyddspump",
    KARCHER_OPERATION_COUNTER_44: "WSO-filterpatroner",
    KARCHER_OPERATION_COUNTER_45: "Uppvärmningspump för tvättstation",
    KARCHER_OPERATION_COUNTER_46: "Varmvattenpump",
    KARCHER_OPERATION_COUNTER_47: "Skumslangvärmare",
    KARCHER_OPERATION_COUNTER_48: "Hjulpumpstvätt",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulsionspump",
    KARCHER_OPERATION_COUNTER_50: "Intensiv skumpump",
    KARCHER_OPERATION_COUNTER_51: "Dammsugare 1 turbin 1",
    KARCHER_OPERATION_COUNTER_52: "Dammsugare 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Dammsugare 1 turbin 2",
    KARCHER_OPERATION_COUNTER_54: "Dammsugare 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Dammsugare 2 turbin 1",
    KARCHER_OPERATION_COUNTER_56: "Dammsugare 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Dammsugare 2 turbin 2",
    KARCHER_OPERATION_COUNTER_58: "Dammsugare 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Dammsugare 3 turbin 1",
    KARCHER_OPERATION_COUNTER_60: "Dammsugare 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Dammsugare 3 turbin 2",
    KARCHER_OPERATION_COUNTER_62: "Dammsugare 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Dammsugare 4 turbin 1",
    KARCHER_OPERATION_COUNTER_64: "Dammsugare 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Dammsugare 4 turbin 2",
    KARCHER_OPERATION_COUNTER_66: "Dammsugare 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Dammsugare 5 turbin 1",
    KARCHER_OPERATION_COUNTER_68: "Dammsugare 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Dammsugare 5 turbin 2",
    KARCHER_OPERATION_COUNTER_70: "Dammsugare 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Dammsugare 6 turbin 1",
    KARCHER_OPERATION_COUNTER_72: "Dammsugare 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Dammsugare 6 turbin 2",
    KARCHER_OPERATION_COUNTER_74: "Dammsugare 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Töm kondensvattnet från kompressorn",
    KARCHER_OPERATION_COUNTER_76: "Kontrollera frostskyddssystemet",
    KARCHER_OPERATION_COUNTER_77: "Brännarfläkt",
    KARCHER_OPERATION_COUNTER_78: "Förstärkt skumpump",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Datalist är större än 10000 objekt",
    KARCHER_POINT_NAME_1: "Helgdag",
    KARCHER_POINT_NAME_2: "Måndag",
    KARCHER_POINT_NAME_3: "Tisdag",
    KARCHER_POINT_NAME_4: "Onsdag",
    KARCHER_POINT_NAME_5: "Torsdag",
    KARCHER_POINT_NAME_6: "Fredag",
    KARCHER_POINT_NAME_7: "Lördag",
    KARCHER_POINT_NAME_8: "Söndag",
    KARCHER_POINT_NAME_9: "Dammsugare Helgdag",
    KARCHER_POINT_NAME_10: "Dammsugare Måndag",
    KARCHER_POINT_NAME_11: "Dammsugare Tisdag",
    KARCHER_POINT_NAME_12: "Dammsugare Onsdag",
    KARCHER_POINT_NAME_13: "Dammsugare Torsdag",
    KARCHER_POINT_NAME_14: "Dammsugare Fredag",
    KARCHER_POINT_NAME_15: "Dammsugare Lördag",
    KARCHER_POINT_NAME_16: "Dammsugare Söndag",
    KARCHER_POINT_NAME_17: "Belysning Helgdag",
    KARCHER_POINT_NAME_18: "Belysning Måndag",
    KARCHER_POINT_NAME_19: "Belysning Tisdag",
    KARCHER_POINT_NAME_20: "Belysning Onsdag",
    KARCHER_POINT_NAME_21: "Belysning Torsdag",
    KARCHER_POINT_NAME_22: "Belysning Fredag",
    KARCHER_POINT_NAME_23: "Belysning Lördag",
    KARCHER_POINT_NAME_24: "Belysning Söndag",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR-kod",
    ACCEPT_TERMS_AND_CONDITIONS: "Godkänn användarvillkoren",
    CREATE_AND_PRINT_VOUCHERS: "Skapa och skriv ut kuponger",
    CODE_PREFIX_QUESTION: "Kodprefix är inte angivet",
    CODE_PREFIX_QUESTION_TEXT: "Vill du fortsätta utan kodprefix?",
    ISSUED_DATE: "Utgivningsdatum",
    VOUCHER_VALIDITY_DAYS: "Kuponggiltighe t (dagar)",
    VALIDATION_ONLY_NUMBERS: "Endast siffror är tillåtna",
    REPRINT_VOUCHERS: "Skriv ut kopia av kuponger",
    EXPIRY_DATE: "Giltig till",
    VOUCHER_TYPE_VACUUM: "Kupong för: Dammsugare",
    VOUCHER_TYPE_JETWASH: "Kupong för: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Kupong för: Matt"
  });
})();
